export const DialogButtonType = {
  WARNING: 'WARNING',
  SUCCESS: 'SUCCESS',
  DANGER: 'DANGER',
}
export const Status = {
  REJECTED: 'REJECTED',
  SUCCESS: 'SUCCESS'
}



// WEBPACK FOOTER //
// ./src/app/shared/confirmation-dialog/ConfirmationDialog.model.ts